import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { User, Languages } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/hooks/auth";
import { useAppLanguage } from "@/hooks/use-app-language";

export function UserMenu() {
  const { user, logout } = useAuth();
  const { t, i18n } = useTranslation();
  const language = useAppLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <User className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>
          {user?.firstName} {user?.lastName}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuLabel className="flex items-center gap-2">
          <Languages className="h-4 w-4" />
          {t("common.language")}
        </DropdownMenuLabel>
        <DropdownMenuItem
          onClick={() => i18n.changeLanguage("en")}
          className={language === "en" ? "bg-accent" : ""}
        >
          {t("common.english")}
          {language === "en" && " ✓"}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => i18n.changeLanguage("de")}
          className={language === "de" ? "bg-accent" : ""}
        >
          {t("common.german")}
          {language === "de" && " ✓"}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => logout()}>
          {t("auth.userMenu.logout")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
